import { searchSynonymApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMasterCompanyId } from 'store/auth/selectors';

export const SEARCH_SYNONYMS_ACTION_TYPE = createNamedActions('searchSynonyms', {
  GET_SEARCH_SYNONYMS: 'GET_SEARCH_SYNONYMS',
  ADD_SEARCH_SYNONYM: 'ADD_SEARCH_SYNONYM',
  UPDATE_SEARCH_SYNONYM: 'UPDATE_SEARCH_SYNONYM',
  DELETE_SEARCH_SYNONYM: 'DELETE_SEARCH_SYNONYM',
});

export const getSearchSynonymsAction = catchAsyncActionError(() => async (dispatch, getState) => {
  const companyId = selectMasterCompanyId(getState());

  const { data } = await searchSynonymApi.getSearchSynonymGroups({ companyId });

  return dispatch({
    type: SEARCH_SYNONYMS_ACTION_TYPE.GET_SEARCH_SYNONYMS,
    payload: data ?? [],
  });
});

export const addSearchSynonymAction = catchAsyncActionError(body => async (dispatch, getState) => {
  const companyId = selectMasterCompanyId(getState());

  const { data } = await searchSynonymApi.createSearchSynonymGroup({ companyId, ...body });

  return dispatch({
    type: SEARCH_SYNONYMS_ACTION_TYPE.ADD_SEARCH_SYNONYM,
    payload: data,
  });
});

export const updateSearchSynonymAction = catchAsyncActionError(
  ({ synonymGroupId, ...body }) =>
    async (dispatch, getState) => {
      const companyId = selectMasterCompanyId(getState());

      // The route id must equal the body id, so echo synonymGroupId into the patch payload.
      const { data } = await searchSynonymApi.updateSearchSynonymGroup({
        companyId,
        synonymGroupId,
        id: synonymGroupId,
        ...body,
      });

      return dispatch({
        type: SEARCH_SYNONYMS_ACTION_TYPE.UPDATE_SEARCH_SYNONYM,
        payload: data,
      });
    },
);

export const deleteSearchSynonymAction = catchAsyncActionError(
  ({ synonymGroupId }) =>
    async (dispatch, getState) => {
      const companyId = selectMasterCompanyId(getState());

      await searchSynonymApi.deleteSearchSynonymGroup({ companyId, synonymGroupId });

      return dispatch({
        type: SEARCH_SYNONYMS_ACTION_TYPE.DELETE_SEARCH_SYNONYM,
        payload: synonymGroupId,
      });
    },
);
